import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ManagersServiceProvider } from '../../api/managers'

const ManagersService = ManagersServiceProvider()
const name = 'managerAssignEmployee'

export default (managerId, employeeId, alternativeCampaignName) => {
  const data = { managerId, employeeId }
  if (alternativeCampaignName) {
    data.alternativeCampaignName = alternativeCampaignName
  }
  return asyncAction(
    name,
    ManagersService.assignEmployee,
    data
  )
}

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/manager/managerAssignEmployee.js